


































































// vendor
import { defineComponent, ref, PropType, set, computed } from "@vue/composition-api";
// project
import { EditCognitiveTestFluid as EditCognitiveTest } from "@/components.edit/edit-cognitive-test";
import { FindAsset } from "@/components.assets/find-asset";
import { AssetPointer } from "@/psychlab/types";
// local
import { CognitiveTestParams } from "../../ts/templates/CognitiveTest";

export default defineComponent({

	components:{
		EditCognitiveTest,
		FindAsset
	},
	props:{
		parameters:{
			type:Object as PropType<CognitiveTestParams>,
			required:true
		}
	},
	setup(props){
		const useAsset = computed({
			get:() => props.parameters.useAsset,
			set:(v) => {
				set(props.parameters, "useAsset", v);
				// this.$forceUpdate();
			}
		});

		const asset = computed({
			get:() => props.parameters.asset,
			set:(v) => props.parameters.asset = v
		});

		return {
			useAsset,
			asset
		};
	}
});

